export default {
    Metadata: {
        Name: "Sign",
        Description: "Returns the sign of a number.",
        Syntax: "Sign(number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(value) {
        if (value == 0) {
            return 0
        }
        else {
            return value > 0 ? 1 : -1;
        }
    },
};

